import { Temporal } from 'temporal-polyfill';
import type { ClockType } from '@/models/common/clock.ts';

export const NOW = Temporal.Instant.from('2026-01-26T10:00:00Z');

class TestClock implements ClockType {
  private now: Temporal.Instant;
  private timeZoneId: string;

  constructor(now: Temporal.Instant, timeZoneId: string) {
    this.now = now;
    this.timeZoneId = timeZoneId;
  }

  getInstant(): Temporal.Instant {
    return this.now;
  }

  getPlainDateISO(): Temporal.PlainDate {
    return this.getZonedDateTimeISO().toPlainDate();
  }

  getTimeZone(): string {
    return this.timeZoneId;
  }

  getZonedDateTimeISO(): Temporal.ZonedDateTime {
    return this.now.toZonedDateTimeISO(this.timeZoneId);
  }

  setZonedDateTimeNow(now: Temporal.ZonedDateTime): void {
    this.now = now.toInstant();
    this.timeZoneId = now.timeZoneId;
  }

  setNow(now: Temporal.Instant): void {
    this.now = now;
  }

  setTimeZone(timeZoneId: string): void {
    this.timeZoneId = timeZoneId;
  }
}

const singleton = new TestClock(NOW, 'UTC');

export const testClock: TestClock = singleton ?? new TestClock(NOW, 'UTC');
